import { render, staticRenderFns } from "./FormOrganization.vue?vue&type=template&id=2fa7f0e6&scoped=true&"
import script from "./FormOrganization.vue?vue&type=script&lang=js&"
export * from "./FormOrganization.vue?vue&type=script&lang=js&"
import style0 from "./FormOrganization.vue?vue&type=style&index=0&id=2fa7f0e6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa7f0e6",
  null
  
)

export default component.exports